import { IconProps } from "./types";

export const IconlyPenSquareBreak = ({
  size = 24,
  color = "currentColor",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3591 3H7.78206C4.84592 3 3.00391 5.08126 3.00391 8.02615V15.9729C3.00391 18.9187 4.83717 21 7.78206 21H16.217C19.1648 21 20.9961 18.9187 20.9961 15.9729V12.3919"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M16.6342 3.91458C17.6476 2.78336 18.8271 3.55531 19.7005 4.33767C20.5738 5.12003 21.4703 6.20784 20.4569 7.33907L13.5959 14.7213C13.2879 15.0651 12.8554 15.2716 12.3945 15.295L10.0766 15.4128C9.76028 15.4289 9.49012 15.1869 9.47144 14.8706L9.33456 12.5538C9.30734 12.0931 9.46524 11.6406 9.77319 11.2969L16.6342 3.91458Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};
